// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/usr/src/app/apps/web-app/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pc__home' */'@/pages/pc/home'), loading: LoadingComponent}),
    "title": "HRready",
    "exact": true
  },
  {
    "path": "/debug/conversation",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__debug-conversation' */'@/pages/debug-conversation'), loading: LoadingComponent}),
    "title": "Conversation 自测",
    "exact": true
  },
  {
    "path": "/promotion",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__invitation__v1' */'@/pages/h5/pages/invitation/v1'), loading: LoadingComponent}),
    "title": "HRready Invitation",
    "hideNavBar": true,
    "exact": true
  },
  {
    "path": "/referrals/rules",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__rules' */'@/pages/h5/pages/rules'), loading: LoadingComponent}),
    "title": "Campaign rules | HRready",
    "hideNavBar": true,
    "exact": true
  },
  {
    "path": "/legal/documents",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreements' */'@/pages/agreements'), loading: LoadingComponent}),
    "title": "Legal Documents | HRready",
    "exact": true
  },
  {
    "path": "/privacy-policy",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreements__privacy-policy' */'@/pages/agreements/privacy-policy'), loading: LoadingComponent}),
    "title": "Privacy Policy | HRready",
    "exact": true
  },
  {
    "path": "/user-agreement",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreements__user-agreement' */'@/pages/agreements/user-agreement'), loading: LoadingComponent}),
    "title": "HRready User Agreement | HRready",
    "exact": true
  },
  {
    "path": "/ai-automated-services-notice",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreements__ai-automated-services-notice' */'@/pages/agreements/ai-automated-services-notice'), loading: LoadingComponent}),
    "title": "AI & Automated Services Notice | HRready",
    "exact": true
  },
  {
    "path": "/communications-ai-calls-policy",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreements__communications-ai-calls-policy' */'@/pages/agreements/communications-ai-calls-policy'), loading: LoadingComponent}),
    "title": "Communications & AI Calls Policy | HRready",
    "exact": true
  },
  {
    "path": "/california-privacy-notice",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__agreements__california-privacy-notice' */'@/pages/agreements/california-privacy-notice'), loading: LoadingComponent}),
    "title": "California Privacy Notice | HRready",
    "exact": true
  },
  {
    "path": "/h5/promotion",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5-promotion__layouts' */'@/pages/h5-promotion/layouts'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/h5/promotion/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5-promotion__pages__login' */'@/pages/h5-promotion/pages/login'), loading: LoadingComponent}),
        "title": "地推登录",
        "exact": true
      },
      {
        "path": "/h5/promotion",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5-promotion__pages__promotion' */'@/pages/h5-promotion/pages/promotion'), loading: LoadingComponent}),
        "title": "地推邀请码",
        "keepAlive": true,
        "exact": true
      },
      {
        "path": "/h5/promotion/performance",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5-promotion__pages__performance' */'@/pages/h5-promotion/pages/performance'), loading: LoadingComponent}),
        "title": "地推业绩",
        "keepAlive": true,
        "exact": true
      },
      {
        "path": "/h5/promotion/reviews/:accountId",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5-promotion__pages__review-detail' */'@/pages/h5-promotion/pages/review-detail'), loading: LoadingComponent}),
        "title": "招聘者审核详情",
        "exact": true
      },
      {
        "path": "/h5/promotion/reviews",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5-promotion__pages__reviews' */'@/pages/h5-promotion/pages/reviews'), loading: LoadingComponent}),
        "title": "用户审核",
        "keepAlive": true,
        "exact": true
      }
    ]
  },
  {
    "path": "/h5",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__layouts' */'@/pages/h5/layouts'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/h5/field-app/download",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__field-app-download' */'@/pages/h5/pages/field-app-download'), loading: LoadingComponent}),
        "title": "Download HRready BD",
        "hideNavBar": true,
        "exact": true
      },
      {
        "path": "/h5",
        "redirect": "/h5/invitation",
        "exact": true
      },
      {
        "path": "/h5/invitation",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__invitation__v1' */'@/pages/h5/pages/invitation/v1'), loading: LoadingComponent}),
        "title": "HRready Invitation",
        "hideNavBar": true,
        "exact": true
      },
      {
        "path": "/h5/invitation/v2",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__invitation__v2' */'@/pages/h5/pages/invitation/v2'), loading: LoadingComponent}),
        "title": "HRready Invitation V2",
        "hideNavBar": true,
        "exact": true
      },
      {
        "path": "/h5/invitation/v3",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__invitation__v3' */'@/pages/h5/pages/invitation/v3'), loading: LoadingComponent}),
        "title": "HRready Invitation V3",
        "hideNavBar": true,
        "exact": true
      },
      {
        "path": "/h5/invitation/rules",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__rules' */'@/pages/h5/pages/rules'), loading: LoadingComponent}),
        "title": "Campaign rules",
        "hideNavBar": true,
        "exact": true
      },
      {
        "path": "/h5/download",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__h5__pages__download' */'@/pages/h5/pages/download'), loading: LoadingComponent}),
        "title": "Download HRready",
        "hideNavBar": true,
        "exact": true
      }
    ]
  },
  {
    "path": "/*",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404__index' */'@/pages/404/index'), loading: LoadingComponent}),
    "title": "页面未找到",
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
